import { isMobile } from "../common/utils";
import LoveIsYouChars from "./love_is_you_chars";

let __sectionName = "#product-2023-content-love-is-you-pc";

let __mode = "ring";
let __font = "cursive";
let __format = "Abc";
let __chain = "kihei";
let __size = "";

let __text = "";
let __chars = null;
let __canvas = null;
let __canvasTmp = null;

const initialize = (mode) => {
  if (isMobile()) {
    __sectionName = "#product-2023-content-love-is-you-sp";
  } else {
    __sectionName = "#product-2023-content-love-is-you-pc";
  }

  __mode = mode;
  const section = document.querySelector(__sectionName);
  section.classList.add("show");

  if (__mode == "ring") {
    initializeModeRing(section);
  } else {
    initializeModeNecklace(section);
  }
  initializeCanvases(section);
  initializeInputText(section);
  initializeSubmitButton(section);
};

const initializeModeRing = (section) => {
  const charRange = section.querySelector("#fs-char-range");
  charRange.innerText = "2~6";

  const designRing = section.querySelector("#fs-select-design-ring");
  designRing.classList.add("show");
  const designButtons = designRing.querySelectorAll(".fs-select-button");
  designButtons.forEach((button) => {
    button.addEventListener("click", () => {
      designButtons.forEach((b) => b.classList.remove("selected"));
      button.classList.add("selected");
      updateDesign(button.dataset.font, button.dataset.format);
    });
  });

  const sizeRing = section.querySelector("#fs-select-size-ring");
  sizeRing.classList.add("show");
  const select = sizeRing.querySelector("select");
  select.addEventListener("change", () => {
    updateSize(select.value);
  });

  const designNecklace = section.querySelector("#fs-select-size-necklace");
  designNecklace.classList.remove("show");
  const sizeNecklace = section.querySelector("#fs-select-size-necklace");
  sizeNecklace.classList.remove("show");

  updateDesign("ring-cursive", "Abc");
  updateSize("");
};

const initializeModeNecklace = (section) => {
  const charRange = section.querySelector("#fs-char-range");
  charRange.innerText = "2~7";

  const designRing = section.querySelector("#fs-select-design-ring");
  designRing.classList.remove("show");
  const sizeRing = section.querySelector("#fs-select-size-ring");
  sizeRing.classList.remove("show");

  const designNecklace = section.querySelector("#fs-select-design-necklace");
  designNecklace.classList.add("show");
  const designButtons = designNecklace.querySelectorAll(".fs-select-button");
  designButtons.forEach((button) => {
    button.addEventListener("click", () => {
      designButtons.forEach((b) => b.classList.remove("selected"));
      button.classList.add("selected");
      updateDesign(button.dataset.font, button.dataset.format);
    });
  });

  const parts = location.pathname.split("-");
  __chain = parts[parts.length - 1];

  const sizeNecklace = section.querySelector("#fs-select-size-necklace");
  sizeNecklace.classList.add("show");
  const select = sizeNecklace.querySelector("select");
  select.addEventListener("change", () => {
    updateSize(select.value);
  });

  updateDesign("necklace-cursive", "Abc");
  updateSize("M: 50cm");
};

const initializeCanvases = (section) => {
  __canvas = section.querySelector("#LoveIsYouCanvas");
  __canvasTmp = section.querySelector("#LoveIsYouCanvasTmp");
};

const initializeInputText = (section) => {
  const input = section.querySelector("#fs-input-text");
  input.addEventListener("input", (e) => {
    updateText(e.target.value);
  });
  setTimeout(() => {
    updateText(input.value);
  }, 500);
};

const initializeSubmitButton = (section) => {
  const button = section.querySelector("#fs-add-to-cart");
  button.addEventListener("click", addToCart);
};

const updateDesign = (font, format) => {
  __font = font;
  __format = format;

  const section = document.querySelector(__sectionName);
  let charSrc = null;
  if (__font == "ring-cursive") {
    // charSrc = section.dataset.ringCursive;
    charSrc = LoveIsYouChars.love_is_you_ring_chars_cursive;
  } else if (__font == "ring-gothic") {
    // charSrc = section.dataset.ringGothic;
    charSrc = LoveIsYouChars.love_is_you_ring_chars_gothic;
  } else if (__font == "necklace-cursive") {
    // charSrc = section.dataset.necklaceCursive;
    charSrc = LoveIsYouChars.love_is_you_necklace_chars_cursive;
  } else {
    // charSrc = section.dataset.necklaceGothic;
    charSrc = LoveIsYouChars.love_is_you_necklace_chars_gothic;
  }

  const chars = new Image();
  chars.onload = () => {
    __chars = chars;
    draw(__text);
  };
  chars.src = charSrc;

  updateText(__text);
  updateInfo();
};

const updateSize = (size) => {
  __size = size;
  updateInfo();
};

const updateText = (text) => {
  if (text.length <= 0) {
    __text = text;
    draw(text);
    return;
  }

  let removed = "";
  for (let i = 0; i < text.length; i++) {
    const c = text.charAt(i);
    const regex = /[a-zA-Z0-9]{1}/;
    if (c.match(regex)) {
      removed = removed + c;
    }
  }
  text = removed;

  if (__format == "Abc") {
    let treated = "";
    for (let i = 0; i < text.length; i++) {
      const c = text.charAt(i);
      const regex = /[a-zA-Z]{1}/;
      if (c.match(regex)) {
        if (treated.length <= 0) {
          treated = treated + c.toUpperCase();
        } else {
          treated = treated + c.toLowerCase();
        }
        continue;
      }
      treated = treated + c;
    }
    text = treated;
  } else if (__format == "ABC") {
    let treated = "";
    for (let i = 0; i < text.length; i++) {
      const c = text.charAt(i);
      const regex = /[a-zA-Z]{1}/;
      if (c.match(regex)) {
        treated = treated + c.toUpperCase();
        continue;
      }
      treated = treated + c;
    }
    text = treated;
  } else if (__format == "abc") {
    let treated = "";
    for (let i = 0; i < text.length; i++) {
      const c = text.charAt(i);
      const regex = /[a-zA-Z]{1}/;
      if (c.match(regex)) {
        treated = treated + c.toLowerCase();
        continue;
      }
      treated = treated + c;
    }
    text = treated;
  }

  if (__mode == "ring") {
    text = text.substring(0, 6);
  } else {
    text = text.substring(0, 7);
  }

  const section = document.querySelector(__sectionName);
  const input = section.querySelector("#fs-input-text");
  input.value = text;

  __text = text;
  updateInfo();
  draw(text);
};

const updateInfo = () => {
  const text = __text.length < 2 ? __text + " (2文字以上入力してください)" : __text;

  let infoText = "";
  if (__mode == "ring") {
    const font = __font == "ring-cursive" ? "筆記体" : "ゴシック体";
    const design = `${font} ${__format}`;

    const size = __size.length <= 0 ? "(選択してください)" : __size;
    infoText = `
      文字: ${text}<br>
      デザイン: ${design}<br>
      サイズ: ${size}
    `;
  } else {
    const font = __font == "cursive" ? "筆記体" : "ゴシック体";
    const design = `${font} ${__format}`;

    const chainNames = {
      kihei: "キヘイ",
      shine: "シャインカット",
      tiered: "ティアスカット",
      marvelous: "マーヴェラス",
    };

    infoText = `
      文字: ${text}<br>
      デザイン: ${design}<br>
      チェーンの種類: ${chainNames[__chain]}<br>
      チェーンの長さ: ${__size}
    `;
  }

  const section = document.querySelector(__sectionName);
  const info = section.querySelector("#fs-info");
  info.innerHTML = infoText;

  const price = section.querySelector("#fs-price");
  const product = currentProduct();
  if (!product) {
    price.innerHTML = "";
  } else {
    const variant = currentVariant(product);
    if (!variant) {
      price.innerHTML = "";
    } else {
      price.innerHTML = `&yen; ${new Intl.NumberFormat("ja-JP").format(variant.price / 100)}`;
    }
  }

  validateButton();
};

const validateButton = () => {
  const section = document.querySelector(__sectionName);
  const button = section.querySelector("#fs-add-to-cart");
  if (2 <= __text.length && 0 < __size.length) {
    button.disabled = false;
    button.classList.remove("disabled");
  } else {
    button.disabled = true;
    button.classList.add("disabled");
  }
};

const draw = (text) => {
  if (!__canvas || !__canvasTmp) {
    return;
  }

  const context = __canvas.getContext("2d");
  context.clearRect(0, 0, __canvas.width, __canvas.height);

  const contextTmp = __canvasTmp.getContext("2d");

  let lastX = 0;
  let lastImageData = null;

  for (let i = 0; i < text.length; i++) {
    const c = text.charAt(i);
    const point = pointAtChar(c);
    if (!point) {
      continue;
    }
    if (i == 0) {
      context.drawImage(__chars, point[0], point[1], 64, 64, 0, 0, 64, 64);
      lastImageData = context.getImageData(0, 0, 64, 64);
      continue;
    }
    contextTmp.clearRect(0, 0, __canvasTmp.width, __canvasTmp.height);
    contextTmp.drawImage(__chars, point[0], point[1], 64, 64, 0, 0, 64, 64);
    const imageData = contextTmp.getImageData(0, 0, 64, 64);

    let overlappingWidth = 60;
    while (0 < overlappingWidth) {
      let overlapped = false;
      for (let y = 0; y < 64; y++) {
        for (let x = 0; x < overlappingWidth; x++) {
          const lastImageDataIndex = (y * 64 + x + (64 - overlappingWidth)) * 4;
          const imageDataIndex = (y * 64 + x) * 4;

          const minAlpha = 128;
          if (minAlpha < lastImageData.data[lastImageDataIndex + 3] && minAlpha < imageData.data[imageDataIndex + 3]) {
            overlapped = true;
            break;
          }
        }
        if (overlapped) {
          break;
        }
      }
      if (!overlapped) {
        break;
      }
      overlappingWidth = overlappingWidth - 1;
    }
    lastImageData = imageData;
    lastX = lastX + 64 - overlappingWidth;
    context.drawImage(__chars, point[0], point[1], 64, 64, lastX, 0, 64, 64);
  }
};

const pointAtChar = (char) => {
  const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let index = upper.indexOf(char);
  if (0 <= index) {
    let x = (index % 10) * 100;
    let y = Math.floor(index / 10) * 100;
    return [x, y];
  }
  const lower = "abcdefghijklmnopqrstuvwxyz";
  index = lower.indexOf(char);
  if (0 <= index) {
    let x = (index % 10) * 100;
    let y = Math.floor(index / 10) * 100 + 300;
    return [x, y];
  }
  const num = "1234567890";
  index = num.indexOf(char);
  if (0 <= index) {
    let x = (index % 10) * 100;
    let y = 600;
    return [x, y];
  }
  return null;
};

const addToCart = () => {
  if (__mode == "ring") {
    const product = currentProduct();
    if (!product) {
      return;
    }
    const variant = product.variants.find((v) => v.option2 == __size);
    if (!variant) {
      return;
    }

    const section = document.querySelector(__sectionName);
    const form = section.querySelector("#fs-form form");

    const inputVariantId = form.querySelector("input[name=id]");
    inputVariantId.value = variant.id;

    const inputPropertiesText = form.querySelector("#properties-text");
    inputPropertiesText.value = __text;
    form.submit();
    return;
  }

  const product = currentProduct();
  if (!product) {
    return;
  }
  const variant = currentVariant(product);
  if (!variant) {
    return;
  }

  const section = document.querySelector(__sectionName);
  const form = section.querySelector("#fs-form form");

  form.setAttribute("id", `product_form_${product.id}`);

  const inputProductId = form.querySelector('input[name="product-id"]');
  inputProductId.value = product.id;

  const inputVariantId = form.querySelector("input[name=id]");
  inputVariantId.value = variant.id;

  const inputPropertiesText = form.querySelector("#properties-text");
  inputPropertiesText.value = __text;

  form.submit();
};

const currentProduct = () => {
  if (__mode == "ring") {
    if (__font == "ring-cursive") {
      return window.fstore.loveIsYouRingCursive;
    }
    return window.fstore.loveIsYouRingGothic;
  }
  if (__chain == "kihei") {
    return window.fstore.loveIsYouNecklaceKihei;
  }
  if (__chain == "shine") {
    return window.fstore.loveIsYouNecklaceShine;
  }
  if (__chain == "tiered") {
    return window.fstore.loveIsYouNecklaceTiered;
  }
  if (__chain == "marvelous") {
    return window.fstore.loveIsYouNecklaceMarvelous;
  }
  return null;
};

const currentVariant = (product) => {
  if (__mode == "ring") {
    return product.variants.find((v) => v.option2 == __size);
  }

  const font = __font == "necklace-cursive" ? "筆記体" : "ゴシック体";
  const design = `${font} ${__format}`;
  return product.variants.find((v) => v.option1 == design && v.option2 == __text.length && v.option3 == __size);
};

if (location.pathname.startsWith("/products/love-is-you-ring")) {
  initialize("ring");
} else if (location.pathname.startsWith("/products/love-is-you-necklace")) {
  initialize("necklace");
}
